// global application types
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT = 'LOGOUT'
export const APP_ERROR = 'APP_ERROR'
export const FORM_ERROR = 'FORM_ERROR'
export const FORM_SUCCESS = 'FORM_SUCCESS'
export const FORM_UID_CHANGED = 'FORM_UID_CHANGED'
export const FORM_RESET_AFTER = 'FORM_RESET_AFTER'
export const DEFAULT_EMAIL = 'DEFAULT_EMAIL'
export const FROM_ROUTE_RESTORED = 'FROM_ROUTE_RESTORED'
export const USER_APP_VISIBLILTY = 'USER_APP_VISIBLILTY'
export const USER_APP_ACTIVITY = 'USER_APP_ACTIVITY'
export const AGENCIES_RECEIVED = 'AGENCIES_RECEIVED'
export const ORGANIZATIONS_RECEIVED = 'ORGANIZATIONS_RECEIVED'
export const SAP_PROMO_CODES_RECEIVED = 'SAP_PROMO_CODES_RECEIVED'
export const FETCHING_SWITCH = 'FETCHING_SWITCH'
export const FILTER_CHANGED = 'FILTER_CHANGED'

export const CUSTOMERS_RECEIVED = 'CUSTOMERS_RECEIVED'
export const SEARCH_CUSTOMERS_RECEIVED = 'SEARCH_CUSTOMERS_RECEIVED'
export const OFFERS_RECEIVED = 'OFFERS_RECEIVED'

// user module
export const USER_DATA_RECEIVED = 'USER_DATA_RECEIVED'
export const SET_ME_PROMISE = 'SET_ME_PROMISE'
export const RESET_ME_PROMISE = 'RESET_ME_PROMISE'
// export const USER_ALL_DATA_RECEIVED = 'USER_ALL_DATA_RECEIVED'
export const USER_AGENCIES_RECEIVED = 'USER_AGENCIES_RECEIVED'

// Tabs module
export const TAB_ACTIVATION = 'TAB_ACTIVATION'
export const TAB_ALTERNATIVE_ACTIVATION = 'TAB_ALTERNATIVE_ACTIVATION'
export const TAB_AVAILABLE_INDEXES_SET = 'TAB_AVAILABLE_INDEXES_SET'
export const TAB_NUMEROTED_SET = 'TAB_NUMEROTED_SET'

// customers module
export const CUSTOMERS_PAGE_RECEIVED = 'CUSTOMERS_PAGE_RECEIVED'
// export const CUSTOMERS_ADDITIONNAL_PAGE_RECEIVED = 'CUSTOMERS_ADDITIONNAL_PAGE_RECEIVED'
export const CUSTOMERS_CURRENT_PAGE_CHANGED = 'CUSTOMERS_CURRENT_PAGE_CHANGED'
export const CUSTOMERS_FILTERS_CHANGED = 'CUSTOMERS_FILTERS_CHANGED'
// customer module
export const CUSTOMER_RECEIVED = 'CUSTOMER_RECEIVED'
export const MAIN_ADDRESS_RECEIVED = 'MAIN_ADDRESS_RECEIVED'
export const BILLING_ADDRESS_RECEIVED = 'BILLING_ADDRESS_RECEIVED'
export const ADDRESSES_RECEIVED = 'ADDRESSES_RECEIVED'
export const REPRESENTATIVES_RECEIVED = 'REPRESENTATIVES_RECEIVED'
export const ORDERS_RECEIVED = 'ORDERS_RECEIVED'
export const CONTRACTS_RECEIVED = 'CONTRACTS_RECEIVED'
export const ORDER_RECEIVED = 'ORDER_RECEIVED'
export const BRANDS_RECEIVED = 'BRANDS_RECEIVED'
export const BRAND_ADDED = 'BRAND_ADDED'
export const BRAND_REMOVED = 'BRAND_REMOVED'
export const BRAND_ARCHIVED = 'BRAND_ARCHIVED'
export const BALANCE_RECEIVED = 'BALANCE_RECEIVED'
export const ACTIVE_FORWARDING_ADDRESS_RECEIVED = 'ACTIVE_FORWARDING_ADDRESS_RECEIVED'
export const DEFAULT_FORWARDING_ADDRESS_RECEIVED = 'DEFAULT_FORWARDING_ADDRESS_RECEIVED'
export const FUTURE_DEFAULT_FORWARDING_ADDRESS_RECEIVED = 'FUTURE_DEFAULT_FORWARDING_ADDRESS_RECEIVED'
export const CUSTOMER_INTERMEDIARY_BUSINESS_RECEIVED = 'CUSTOMER_INTERMEDIARY_BUSINESS_RECEIVED'
export const CUSTOMER_INTERMEDIARY_BUSINESS_REMOVED = 'CUSTOMER_INTERMEDIARY_BUSINESS_REMOVED'
export const CUSTOMER_INTERMEDIARY_BUSINESS_ADDED = 'CUSTOMER_INTERMEDIARY_BUSINESS_ADDED'
export const CUSTOMER_SAP_ORGANIZATIONS_RECEIVED = 'CUSTOMER_SAP_ORGANIZATIONS_RECEIVED'

export const CUSTOMER_CHANGED = 'CUSTOMER_CHANGED'
export const CUSTOMER_COMMENTS_CHANGED = 'CUSTOMER_COMMENTS_CHANGED'
export const CUSTOMER_DEFAULT_BUYER_UPDATED = 'CUSTOMER_DEFAULT_BUYER_UPDATED'
export const ADDRESS_CHANGED = 'ADDRESS_CHANGED'
export const ADDRESS_ADDED = 'ADDRESS_ADDED'
export const REPRESENTATIVE_CHANGED = 'REPRESENTATIVE_CHANGED'
export const REPRESENTATIVE_ADDED = 'REPRESENTATIVE_ADDED'
export const REPRESENTATIVE_ADDRESS_CHANGED = 'REPRESENTATIVE_ADDRESS_CHANGED'
export const REPRESENTATIVE_ADDRESS_ADDED = 'REPRESENTATIVE_ADDRESS_ADDED'
export const REPRESENTATIVE_MAIN_CHANGED = 'REPRESENTATIVE_MAIN_CHANGED'
export const REPRESENTATIVE_REMOVED = 'REPRESENTATIVE_REMOVED'
export const SEND_TO_SAP_COMPLETED = 'SEND_TO_SAP_COMPLETED'

export const CUSTOMER_EXPECTED_DOCUMENTS_FETCHED = 'CUSTOMER_EXPECTED_DOCUMENTS_FETCHED'
export const CUSTOMER_INTERNAL_DOCUMENTS_FETCHED = 'CUSTOMER_INTERNAL_DOCUMENTS_FETCHED'
// V2
export const CUSTOMER_VALIDATION_REQUESTS_FETCHED = 'CUSTOMER_VALIDATION_REQUESTS_FETCHED'

export const CUSTOMER_MAIL_SCANS_FETCHED = 'CUSTOMER_MAIL_SCANS_FETCHED'

//contract module
export const CONTRACT_RECEIVED = 'CONTRACT_RECEIVED'
export const RESET_INSTRUCTIONS = 'RESET_INSTRUCTIONS'
export const INSTRUCTIONS_RECEIVED = 'INSTRUCTIONS_RECEIVED'
export const ACTIVE_FORWARDING_ADDRESSES_RECEIVED = 'ACTIVE_FORWARDING_ADDRESSES_RECEIVED'
export const PUNCTUALS_FORWARDING_ADDRESSES_RECEIVED = 'PUNCTUALS_FORWARDING_ADDRESSES_RECEIVED'
export const MAIL_OPTION_DETERMINED = 'MAIL_OPTION_DETERMINED'
export const OPTIONS_INSTRUCTIONS_RECEIVED = 'OPTIONS_INSTRUCTIONS_RECEIVED'
export const FULLOFFERS_RECEIVED = 'FULLOFFERS_RECEIVED'

//MAIL_WITHDRAWAL_PROXIES
export const MAIL_WITHDRAWAL_PROXIES_RECEIVED = 'MAIL_WITHDRAWAL_PROXIES_RECEIVED'
export const MAIL_WITHDRAWAL_PROXY_ADDED = 'MAIL_WITHDRAWAL_PROXY_ADDED'
export const MAIL_WITHDRAWAL_PROXY_REMOVED = 'MAIL_WITHDRAWAL_PROXY_REMOVED'

//hotline contacts
export const HOTLINE_CONTACTS_RECEIVED = 'HOTLINE_CONTACTS_RECEIVED'
export const HOTLINE_CONTACT_ADDED = 'HOTLINE_CONTACT_ADDED'
export const HOTLINE_CONTACT_UPDATED = 'HOTLINE_CONTACT_UPDATED'
export const HOTLINE_CONTACT_REMOVED = 'HOTLINE_CONTACT_REMOVED'

//mainification
export const REPRESENTATIVE_MAINIFICATION_FORM_RECEIVED = 'REPRESENTATIVE_MAINIFICATION_FORM_RECEIVED'

export const CUSTOMERS_SORT_PARAMS_CHANGED = 'CUSTOMERS_SORT_PARAMS_CHANGED'


//consumption module
export const CONSUMPTIONS_RECEIVED = 'CONSUMPTION_RECEIVED'
export const CONSUMPTION_ADDED = 'CONSUMPTION_ADDED'
export const PARAMS_CHANGED = 'PARAMS_CHANGED'
export const AGENCY_CHANGED = 'AGENCY_CHANGED'
export const DEFAULT_PRICE_LIST_CHANGED = 'DEFAULT_PRICE_LIST_CHANGED'
export const PRICE_LIST_CHOSEN = 'PRICE_LIST_CHOSEN'
export const PRICE_LIST_FLAG = 'PRICE_LIST_FLAG'
export const MAIL_FORWARDING_PACKAGE_CHECKED = 'MAIL_FORWARDING_PACKAGE_CHECKED'
export const UID_INCREMENTED = 'UID_INCREMENTED'
export const REQUEST_TOKEN_SOURCE_CHANGED = 'REQUEST_TOKEN_SOURCE_CHANGED'

// Catalog module
export const CATALOG_DOM_RECEIVED = 'CATALOG_DOM_RECEIVED'
export const CATALOG_LLD_RECEIVED = 'CATALOG_LLD_RECEIVED'
export const CATALOG_PON_RECEIVED = 'CATALOG_PON_RECEIVED'
export const CATALOG_INB_RECEIVED = 'CATALOG_INB_RECEIVED'

// Cart module
export const CARTS_RECEIVED = 'CARTS_RECEIVED' // fetchCarts
export const CART_RECEIVED = 'CART_RECEIVED' //fectchCartById
export const CART_CREATED = 'CART_CREATED' //createCatalog
export const CART_ACTIVE_RECEIVED = 'CART_ACTIVE_RECEIVED' //getactivecart
export const CART_UPDATED = 'CART_UPDATED' //update cart

export const CART_SET_CURRENT_STEP = 'CART_SET_CURRENT_STEP'
export const CART_SET_OWNER = 'CART_SET_OWNER'
export const CART_SET_PASSING_CUSTOMER = 'CART_SET_PASSING_CUSTOMER'
export const CART_ATTACH_TO_CUSTOMER = 'CART_ATTACH_TO_CUSTOMER'
export const CART_RESET_OWNER = 'CART_RESET_OWNER'
export const CART_ADD_OFFER = 'CART_ADD_OFFER'
export const CART_RECOMPUTE_PRICE = 'CART_RECOMPUTE_PRICE'

export const CART_CHANGE_DOM_OFFER = 'CART_CHANGE_DOM_OFFER'
export const CART_CLEAN = 'CART_CLEAN'
export const CART_ACTIVE_CLEAN = 'CART_ACTIVE_CLEAN'
export const CART_PURCHASE_TUNNEL_MANIFEST = 'CART_PURCHASE_TUNNEL_MANIFEST'
export const CART_PURCHASE_STEPS = 'CART_PURCHASE_STEPS'
export const CART_PURCHASE_CART_STEP = 'CART_PURCHASE_CART_STEP'
export const CART_PURCHASE_CONNECTION_STEP = 'CART_PURCHASE_CONNECTION_STEP'
export const CART_TUNNEL_INFORMATION_STEP_EDITION_STATUS = 'CART_TUNNEL_INFORMATION_STEP_EDITION_STATUS'

// Cart company
export const CART_COMPANY_STORE = 'CART_COMPANY_STORE'
export const CART_COMPANY_UPDATE_OFFER = 'CART_COMPANY_UPDATE_OFFER'
export const CART_COMPANY_UPDATE_QUANTITY = 'CART_COMPANY_UPDATE_QUANTITY'
export const CART_COMPANY_UPDATE_INFOS = 'CART_COMPANY_UPDATE_INFOS'
export const CART_COMPANY_DELETE = 'CART_COMPANY_DELETE'
// Cart SUBORDER
export const CART_SUBORDER_STORE = 'CART_SUBORDER_STORE'
export const CART_SUBORDER_UPDATE_OFFER = 'CART_SUBORDER_UPDATE_OFFER'
export const CART_SUBORDER_UPDATE_QUANTITY = 'CART_SUBORDER_UPDATE_QUANTITY'
export const CART_SUBORDER_UPDATE_INFO = 'CART_SUBORDER_UPDATE_INFO'
export const CART_SUBORDER_DELETE = 'CART_SUBORDER_DELETE'
// Cart Suborder option
export const CART_STORE_OPTION = 'CART_STORE_OPTION'
export const CART_UPDATE_OPTION = 'CART_UPDATE_OPTION'
export const CART_DELETE_OPTION = 'CART_UPDATE_OPTION'
export const CART_GET_OWNER_RECEIVED = 'CART_GET_OWNER_RECEIVED'
export const CART_OFFER_INFO_RECEIVED = 'CART_OFFER_INFO_RECEIVED'

// Demandes
export const DEMANDS_RECEIVED = 'DEMANDS_RECEIVED'
export const DEMANDS_FILTERS_UPDATED = 'DEMANDS_FILTERS_UPDATED'
export const DEMANDS_CANDIDATES = 'DEMANDS_CANDIDATES'
export const DEMANDS_VALIDATION_REQUESTS = 'DEMANDS_VALIDATION_REQUESTS'
export const DEMANDS_VALIDATION_TREATMENT_FORM = 'DEMANDS_VALIDATION_TREATMENT_FORM'
export const DEMANDS_VALIDATED = 'DEMANDS_VALIDATED'
export const DEMANDS_REFUSED = 'DEMANDS_REFUSED'
export const DEMANDS_SINGLE_VALIDATION_REQUESTS = 'DEMANDS_SINGLE_VALIDATION_REQUESTS'
export const DEMANDS_CUSTOMER_RELATED = 'DEMANDS_CUSTOMER_RELATED'
export const DEMANDS_SORT_UPDATED = 'DEMANDS_SORT_UPDATED'
export const DEMANDS_USER_INFOS = 'DEMANDS_USER_INFOS'
export const DEMANDS_PAYMENTS_METHODS = 'DEMANDS_PAYMENTS_METHODS'
export const DEMANDS_FLUSH_STATE = 'DEMANDS_FLUSH_STATE'
export const DEMANDS_ATTACH_SAP_CUSTOMER = 'DEMANDS_ATTACH_SAP_CUSTOMER'
export const DEMANDS_MAKE_PAYMENT = 'DEMANDS_MAKE_PAYMENT'
export const DEMANDS_ORDER_OPTIONS = 'DEMANDS_ORDER_OPTIONS'
export const ORDER_CANCEL_AUTORIZATION = "ORDER_CANCEL_AUTORIZATION"
export const ORDER_CAPTURE_AUTORIZATION = "ORDER_CAPTURE_AUTORIZATION"
export const DEMANDS_ORDER_OPTIONS_RESET = "DEMANDS_ORDER_OPTIONS_RESET"
export const DEMAND_OPTIONAL_PARAMS_SET = "DEMAND_OPTIONAL_PARAMS_SET"
export const DEMAND_CURRENT_TREATING_DEMAND_SET = "DEMAND_CURRENT_TREATING_DEMAND_SET"
// V2
export const VALIDATION_REQUESTS_FETCHED = 'VALIDATION_REQUESTS_FETCHED'
export const VALIDATION_REQUESTS_FILTERS_UPDATED = 'VALIDATION_REQUESTS_FILTERS_UPDATED'
export const VALIDATION_REQUESTS_SORT_UPDATED = 'VALIDATION_REQUESTS_SORT_UPDATED'
export const VALIDATION_REQUEST_FETCHED = 'VALIDATION_REQUEST_FETCHED'

// Dashboard
export const DASHBOARD_VALIDATION_REQUESTS_RECEIVED = 'DASHBOARD_VALIDATION_REQUESTS_RECEIVED'
export const DASHBOARD_SINGLE_VALIDATION_REQUEST_RECEIVED = 'DASHBOARD_SINGLE_VALIDATION_REQUEST_RECEIVED'
export const DASHBOARD_VALIDATION_REQUEST_TREATMENT_FORM_RECEIVED = 'DASHBOARD_VALIDATION_REQUEST_TREATMENT_FORM_RECEIVED'
export const DASHBOARD_VALIDATION_REQUEST_VALIDATED = 'DASHBOARD_VALIDATION_REQUEST_VALIDATED'
export const DASHBOARD_VALIDATION_REQUEST_REFUSED = 'DASHBOARD_VALIDATION_REQUEST_REFUSED'
export const DASHBOARD_STATS_RECEIVED = 'DASHBOARD_STATS_RECEIVED'
export const DASHBOARD_BOOKINGS_RECEIVED = 'DASHBOARD_BOOKINGS_RECEIVED'

export const VALIDATION_REQUEST_EXPECTED_DOCUMENTS_FETCHED = 'VALIDATION_REQUEST_EXPECTED_DOCUMENTS_FETCHED'

// Invoices
export const INVOICES_RECEIVED = 'INVOICES_RECEIVED'
// Cash
export const CASH_ORDERS_RECEIVED = 'CASH_ORDERS_RECEIVED'
export const CASH_CUSTOMERS_RECEIVED = 'CASH_CUSTOMERS_RECEIVED'
export const CASH_PAYMENT_METHOD_RECEIVED = 'CASH_PAYMENT_METHOD_RECEIVED'
export const CASH_VALIDATION_REQUESTS_RECEIVED = 'CASH_VALIDATION_REQUESTS_RECEIVED'
export const CASH_CUSTOMERS_FOR_ADD_CASH_RECEIVED = 'CASH_CUSTOMERS_FOR_ADD_CASH_RECEIVED'
export const CASH_CUSTOMER_CASHINGS_RECEIVED = 'CASH_CUSTOMER_CASHINGS_RECEIVED'
export const CASH_CUSTOMER_CASHINGS_PAYMENT_FORM_RECEIVED = 'CASH_CUSTOMER_CASHINGS_PAYMENT_FORM_RECEIVED'
// export const CASH_CUSTOMER_CASHINGS = 'CASH_CUSTOMER_CASHINGS'
export const CASH_CUSTOMER_INVOICES_RECEIVED = 'CASH_CUSTOMER_INVOICES_RECEIVED'
export const CASH_AGENCIES_WITH_ORGANIZATION_RECEIVED = 'CASH_AGENCIES_WITH_ORGANIZATION_RECEIVED'
export const CASH_CUSTOMER_RECEIVED = 'CASH_CUSTOMER_RECEIVED'
export const CASH_CUSTOMER_CASHINGS_FILTER_UPDATED = 'CASH_CUSTOMER_CASHINGS_FILTER_UPDATED'
export const CASH_CUSTOMER_CASHING_CREATED_AND_WAITING_FOR_PAYMENT = 'CASH_CUSTOMER_CASHING_CREATED_AND_WAITING_FOR_PAYMENT'
export const CASH_ORGANIZATIONS_OF_CUSTOMER = 'CASH_ORGANIZATIONS_OF_CUSTOMER'
export const CASH_CUSTOMER_BALANCE_RECEIVED = 'CASH_CUSTOMER_BALANCE_RECEIVED'

// Sandbox Form Fetching
export const CART_COMPANY_CREATION_FORM_FETCHED = 'CART_COMPANY_CREATION_FORM_FETCHED'
export const CART_COMPANY_EDITION_FORM_FETCHED = 'CART_COMPANY_EDITION_FORM_FETCHED'
export const CONTRACT_EDITION_FORM_FETCHED = 'CONTRACT_EDITION_FORM_FETCHED'
export const CONTRACT_INSTRUCTION_EDITION_FORM_FETCHED = 'CONTRACT_INSTRUCTION_EDITION_FORM_FETCHED'
export const CONTRACT_OPTION_INSTRUCTION_EDITION_FORM_FETCHED = 'CONTRACT_OPTION_INSTRUCTION_EDITION_FORM_FETCHED'
export const CONTRACT_OPTION_ADDRESSE_CREATION_FORM_FETCHED = 'CONTRACT_OPTION_ADDRESSE_CREATION_FORM_FETCHED'
export const CONTRACT_OPTION_ADDRESSE_EDITION_FORM_FETCHED = 'CONTRACT_OPTION_ADDRESSE_EDITION_FORM_FETCHED'
export const CUSTOMER_EDITION_FORM_FETCHED = 'CUSTOMER_EDITION_FORM_FETCHED'
export const CUSTOMER_ADDRESSE_CREATION_FORM_FETCHED = 'CUSTOMER_ADDRESSE_CREATION_FORM_FETCHED'
export const CUSTOMER_ADDRESSE_EDITION_FORM_FETCHED = 'CUSTOMER_ADDRESSE_EDITION_FORM_FETCHED'
export const CUSTOMER_REPRESENTATIVE_CREATION_FORM_FETCHED = 'CUSTOMER_REPRESENTATIVE_CREATION_FORM_FETCHED'
export const CUSTOMER_REPRESENTATIVE_EDITION_FORM_FETCHED = 'CUSTOMER_REPRESENTATIVE_EDITION_FORM_FETCHED'
export const CUSTOMER_REPRESENTATIVE_INFOS_EDITION_FORM_FETCHED = 'CUSTOMER_REPRESENTATIVE_INFOS_EDITION_FORM_FETCHED'
export const CUSTOMER_REPRESENTATIVE_ADDRESSE_EDITION_FORM_FETCHED = 'CUSTOMER_REPRESENTATIVE_ADDRESSE_EDITION_FORM_FETCHED'
export const CUSTOMER_MAINIFICATION_FORM_FETCHED = 'CUSTOMER_MAINIFICATION_FORM_FETCHED'
export const LEAD_CONTACT_CREATE = 'LEAD_CONTACT_CREATE'
export const LEAD_CONTACT_EDIT = 'LEAD_CONTACT_EDIT'
// Sandbox Form Submiting

// BOOKINGS
export const BOOKINGS_RECEIVED = 'BOOKINGS_RECEIVED'
export const BOOKINGS_UNAVAILABILITY_RECEIVED = 'BOOKINGS_UNAVAILABILITY_RECEIVED'
export const BOOKINGS_FILTERS_CHANGED = 'BOOKINGS_FILTERS_CHANGED'
export const BOOKINGS_DATE_FILTER_CHANGED = 'BOOKINGS_DATE_FILTER_CHANGED'
export const BOOKING_CANCELED_FILTER_CHANGED = 'BOOKING_CANCELED_FILTER_CHANGED'

// ORDERS
export const HIGHLIGHT_ORDER = 'HIGHLIGHT_ORDER'

// Hotline
// Hotline previously
export const HOTLINE_CUSTOMERS_RECEIVED = 'HOTLINE_CUSTOMERS_RECEIVED'
export const HOTLINE_SEARCH_FILTERS_UPDATED = 'HOTLINE_SEARCH_FILTERS_UPDATED'
export const HOTLINE_MESSAGES_RECEVIVED = 'HOTLINE_MESSAGES_RECEVIVED'
export const HOTLINE_MESSAGES_FILTERS_UPDATED = 'HOTLINE_MESSAGES_FILTERS_UPDATED'

// Hotline current
export const HOTLINE_MESSAGES_CREATED = 'HOTLINE_MESSAGES_CREATED'
export const HOTLINE_MESSAGES_RECEIVED = 'HOTLINE_MESSAGES_RECEIVED'
export const HOTLINE_CUSTOMERS_MESSAGES_RECEIVED = 'HOTLINE_CUSTOMERS_MESSAGES_RECEIVED'
export const HOTLINE_MESSAGE_RECEIVED = 'HOTLINE_MESSAGE_RECEIVED'
export const HOTLINE_MESSAGE_EDITED = 'HOTLINE_MESSAGE_EDITED'
export const HOTLINE_MESSAGE_ARCHIVED = 'HOTLINE_MESSAGE_ARCHIVED'
export const HOTLINE_MESSAGE_UNARCHIVED = 'HOTLINE_MESSAGE_UNARCHIVED'
export const HOTLINE_CONTRACTS_RECEIVED = 'HOTLINE_CONTRACTS_RECEIVED'
// export const HOTLINE_CUSTOMER_REVEICED = 'HOTLINE_CUSTOMER_REVEICED'

// crm
export const CRM_LEADS_RECEIVED = 'CRM_LEADS_RECEIVED'
export const CRM_LEAD_RECEIVED = 'CRM_LEAD_RECEIVED'
export const CRM_LEAD_ADDED = 'CRM_LEAD_ADDED'
export const CRM_LEAD_STATUS_UPDATED = 'CRM_LEAD_STATUS_UPDATED'
export const CRM_CONTACTS_OF_LEAD_RECEIVED = 'CRM_CONTACTS_OF_LEAD_RECEIVED'
export const CRM_CONTACT_ADDED_TO_LEAD = 'CRM_CONTACT_ADDED_TO_LEAD'
export const CRM_CONTACT_REMOVED = 'CRM_CONTACT_REMOVED'
export const CRM_CREATE_CONTACT_FORM_RECEIVED = 'CRM_CREATE_CONTACT_FORM_RECEIVED'
export const CRM_EDIT_CONTACT_FORM_RECEIVED = 'CRM_EDIT_CONTACT_FORM_RECEIVED'
export const CRM_CONTACT_EDITED = 'CRM_CONTACT_EDITED'
export const CRM_CUSTOMERS_RECEIVED = 'CRM_CUSTOMERS_RECEIVED'
export const CRM_ATTACH_CUSTOMER_TO_LEAD = 'CRM_ATTACH_CUSTOMER_TO_LEAD'
export const CRM_UNATTACH_CUSTOMER_FROM_LEAD = 'CRM_UNATTACH_CUSTOMER_FROM_LEAD'
export const CRM_USERS_FETCHED = 'CRM_USERS_FETCHED'
export const CRM_INTERACTIONS_RECEIVED = 'CRM_INTERACTIONS_RECEIVED'
export const CRM_INTERACTION_CREATED = 'CRM_INTERACTION_CREATED'
export const CRM_INTERACTION_DELETED = 'CRM_INTERACTION_DELETED'
export const CRM_INTERACTION_UPDATED = 'CRM_INTERACTION_UPDATED'
export const CRM_SCHEDULED_INTERACTION_CREATED = 'CRM_SCHEDULED_INTERACTION_CREATED'
export const CRM_SCHEDULED_INTERACTION_UPDATED = 'CRM_SCHEDULED_INTERACTION_UPDATED'
export const CRM_SCHEDULED_INTERACTION_REALIZED = 'CRM_SCHEDULED_INTERACTION_REALIZED'
export const CRM_OFFERS_RECEIVED = 'CRM_OFFERS_RECEIVED'
export const CRM_OFFER_ATTACHED = 'CRM_OFFER_ATTACHED'
export const CRM_OFFER_DETACHED = 'CRM_OFFER_DETACHED'
export const CRM_DISTRIBUTION_METHOD_ATTACHED = 'CRM_DISTRIBUTION_METHOD_ATTACHED'
export const CRM_DISTRIBUTION_METHOD_DETACHED = 'CRM_DISTRIBUTION_METHOD_DETACHED'
export const CRM_DISTRIBUTIONS_METHODS_RECEIVED = 'CRM_DISTRIBUTIONS_METHODS_RECEIVED'
export const CRM_MEDIAS_RECEIVED = 'CRM_MEDIAS_RECEIVED'
export const CRM_AGENCIES_RECEIVED = 'CRM_AGENCIES_RECEIVED'
export const CRM_LEAD_FOR_EXPORT = 'CRM_LEAD_FOR_EXPORT'
export const CRM_LEAD_ORIGIN_SUPPLEMENT_UPDATED = 'CRM_LEAD_ORIGIN_SUPPLEMENT_UPDATED'
export const CRM_LEAD_DELETED = 'CRM_LEAD_DELETED'
export const CRM_LEAD_AGENCY_UPDATED = 'CRM_LEAD_AGENCY_UPDATED'
export const CRM_OFFER_SUPPLEMENT_UPDATED = 'CRM_OFFER_SUPPLEMENT_UPDATED'
export const CRM_USER_GROUPS_RECEIVED = 'CRM_USER_GROUPS_RECEIVED'

// Manual notifications
export const MANUAL_NOTIFICATIONS_RECEIVED = 'MANUAL_NOTIFICATIONS_RECEIVED'
export const CUSTOMER_MANUAL_NOTIFICATIONS_RETRIEVED = 'CUSTOMER_MANUAL_NOTIFICATIONS_RETRIEVED'

// Loyalty Program Subscriptions
export const LOYALTY_PROGRAMS_RECEIVED = 'LOYALTY_PROGRAMS_RECEIVED'
export const LOYALTY_PROGRAM_NEW_SUBS_INFOS_RECEIVED = 'LOYALTY_PROGRAM_NEW_SUBS_INFOS_RECEIVED'
export const LOYALTY_PROGRAM_SUBSCRIBED_CUSTOMERS = 'LOYALTY_PROGRAM_SUBSCRIBED_CUSTOMERS'
export const CUSTOMER_LOYALTY_PROGRAM_SUBSCRIPTIONS_RETRIEVED = 'CUSTOMER_LOYALTY_PROGRAM_SUBSCRIPTIONS_RETRIEVED'
export const LOYALTY_PROGRAM_POINTS_COUNT_SIMULATION_UPDATED = 'LOYALTY_PROGRAM_POINTS_COUNT_SIMULATION_UPDATED'
export const LOYALTY_PROGRAM_POINTS_COUNT_SIMULATION_RESET = 'LOYALTY_PROGRAM_POINTS_COUNT_SIMULATION_RESET'

/* Beneficial Owners */
export const BENEFICIAL_OWNERS_UPDATE_FORM_DISPLAYED_VALUE = 'BENEFICIAL_OWNERS_UPDATE_FORM_DISPLAYED_VALUE'
export const BENEFICIAL_OWNERS_DECLARATION_FETCHED = 'BENEFICIAL_OWNERS_DECLARATION_FETCHED'
export const BENEFICIAL_OWNERS_INPI_DOCUMENTS_FETCHED = 'BENEFICIAL_OWNERS_INPI_DOCUMENTS_FETCHED'
export const BENEFICIAL_OWNERS_LIST_FETCHED = 'BENEFICIAL_OWNERS_LIST_FETCHED'
export const BENEFICIAL_OWNER_CREATION_FORM_FETCHED = 'BENEFICIAL_OWNER_CREATION_FORM_FETCHED'
export const BENEFICIAL_OWNER_EDITION_FORM_FETCHED = 'BENEFICIAL_OWNER_EDITION_FORM_FETCHED'


// WEBPACK FOOTER //
// ./client/store/mutation-types.js